<template>
  <div v-if="deadLine" class="order-dead-line-timer">
    <div class="timer" :class="{'timer-negative': isNegative}">
      {{ timerString }}
    </div>
    <div v-if="isNegative" class="label">
      Опоздание <span class="label-suffix"><br /> заказа</span>
    </div>
    <div v-else-if="isStoppedAtReady" class="label">
      Готов <span class="label-suffix"><br /> вовремя</span>
    </div>
    <div v-else class="label">
      Осталось <span class="label-suffix"><br /> времени</span>
    </div>
  </div>
</template>

<script>
  import { DateTime } from 'luxon'

  // Причина остановки таймера с бэка (App\Enums\TimerStopReason), при которой заказ «готов вовремя».
  const TIMER_STOP_REASON_READY_FOR_ISSUE = 'readyForIssue'

  export default {
    name: 'OrderDeadLineTimer',
    props: {
      deadLine: {
        type: String,
        default: null,
      },
      // Момент остановки таймера (ISO). Пока null, таймер идёт от текущего времени.
      stoppedAt: {
        type: String,
        default: null,
      },
      // Причина остановки: readyForIssue / completed / canceled.
      stopReason: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        timer: null,
        difference: null,
      }
    },
    computed: {
      deadlineDateTime () {
        return DateTime.fromISO(this.deadLine)
      },
      absDifference () {
        return Math.abs(this.difference)
      },

      hours () {
        return Math.floor(this.absDifference / (60 * 60))
      },
      minutes () {
        return Math.floor((this.absDifference % (60 * 60)) / (60))
      },
      seconds () {
        return Math.floor((this.absDifference % 60))
      },
      isNegative () {
        return this.difference < 0
      },
      isStoppedAtReady () {
        return !!this.stoppedAt && this.stopReason === TIMER_STOP_REASON_READY_FOR_ISSUE
      },

      timerString () {
        if (this.difference) {
          let res = ''

          if (this.isNegative) {
            res += '-'
          }

          if (this.hours) {
            res += this.hours
            res += ':'
          }
          res += this.minutes < 10 ? `0${this.minutes}` : this.minutes
          res += ':'
          res += this.seconds < 10 ? `0${this.seconds}` : this.seconds

          return res
        }
        return null
      },
    },
    watch: {
      stoppedAt (newValue) {
        if (newValue) {
          this.stopTimer()
          this.calcDifference()
        }
      },
      isNegative: {
        // immediate: заказ, загрузившийся уже опоздавшим, тоже должен покрасить степпер.
        immediate: true,
        handler (newValue) {
          this.$emit('lateness', newValue)
        },
      },
      deadLine (newValue) {
        this.calcDifference()
        if (newValue && !this.stoppedAt) {
          this.startTimer()
        } else {
          this.stopTimer()
        }
      },
    },
    created () {
      this.calcDifference()
      if (this.deadLine && !this.stoppedAt) {
        this.startTimer()
      }
    },
    beforeDestroy () {
      this.stopTimer()
    },
    methods: {
      getEndDateTime () {
        if (this.stoppedAt) {
          return DateTime.fromISO(this.stoppedAt)
        }
        return DateTime.local()
      },
      calcDifference () {
        this.difference = this.deadlineDateTime.diff(this.getEndDateTime()).as('seconds')
      },
      stopTimer () {
        clearInterval(this.timer)
      },
      startTimer () {
        this.stopTimer()

        this.timer = setInterval(() => {
          this.calcDifference()
        }, 1000)
      },
    },
  }
</script>

<style lang="less" scoped>
.order-dead-line-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
  .media-lg({
    align-items: flex-start;
  });

  .timer {
    color: #1ee984;
    font-size: 22px;
    font-weight: 500;
    line-height: 30px;
    white-space: nowrap;
    .media-lg({
      font-size: 20px;
    });
    .media-xl({
      font-size: 25px;
    });

    &.timer-negative {
      color: #E91E63;
    }
  }

  .label {
    font-size: 14px;
    line-height: 1;
    text-align: center;

    @media (max-width: 1700px) {
      font-size: 13px;
    }

    @media (max-width: 1500px) {
      font-size: 12px;
      .label-suffix {
        display: none !important;
      }
    }

  }

  .media-lg({
    .label-suffix {
      display: none !important;
    }
  });
}
</style>
